import { FC } from 'react';
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { map as lodashMap } from 'lodash';
import { PlayerMeta } from '../../../types';
import { CbParticipantSelectCard, CbParticipantSelectedCard } from './CbParticipantCards';
import { CbParticipantCardHeader } from './CbPaticipantPickerHeader';
export interface CbParticipantPickerLayoutProps {
  availablePlayers: PlayerMeta[];
  selectedParticipants: PlayerMeta[];
  handleAddParticipant: (player: PlayerMeta) => void;
  handleRemoveParticipant: (index: number, id: number) => void;
  handleAddAllParticipants: () => void;
  handleClearAllParticipants: () => void;
  handlePrimarySelected?: (id: number, notificationsEnabled: boolean, participantId?: string | number) => void;
  showNotificationSettings?: boolean;
  teamId?: number;
  maxHeight?: string;
}
export const CbParticipantPickerLayout: FC<CbParticipantPickerLayoutProps> = ({
  availablePlayers,
  selectedParticipants,
  teamId,
  handleAddParticipant,
  handleRemoveParticipant,
  handleAddAllParticipants,
  handleClearAllParticipants,
  handlePrimarySelected,
  showNotificationSettings = false,
  maxHeight
}) => {
  /*  Used to suppress Player notification settings until their
      team membership is persisted */
  const teamMembershipPersisted = (participant: PlayerMeta) => {
    const playerTeamIds = lodashMap(participant.teams, 'id');
    return !!teamId && playerTeamIds.includes(teamId);
  };
  return <>
      <Grid width={{
      sm: '94%',
      md: '100%'
    }} templateColumns="repeat(2, 1fr)" gap={5} data-sentry-element="Grid" data-sentry-source-file="CbParticipantPickerLayout.tsx">
        <GridItem data-sentry-element="GridItem" data-sentry-source-file="CbParticipantPickerLayout.tsx">
          <CbParticipantCardHeader title="Add Learners" buttonText="Add All" listLength={availablePlayers?.length || 0} ariaLabel="Add all participants" btnColor="white" hoverColor="chonky.700" handleClick={handleAddAllParticipants} data-sentry-element="CbParticipantCardHeader" data-sentry-source-file="CbParticipantPickerLayout.tsx" />

          {availablePlayers?.length == 0 ? <Text fontSize={{
          md: '12px'
        }} fontFamily="codenext" color={'luigisPants.200'} marginTop={6}>
              {' All learners selected '}
            </Text> : <Box border="2px solid" borderColor="cloud.300" borderRadius={6} marginTop={4} padding={1} maxHeight={maxHeight} overflowY="auto">
              {availablePlayers?.map((participant, index) => {
            const isOddRow = (index + 1) % 2;
            return <CbParticipantSelectCard key={participant.id} isOddRow={isOddRow} name={participant.name} imageUrl={participant.profileImage} handleClick={() => handleAddParticipant(participant)} handlePrimarySelected={() => {}} />;
          })}
            </Box>}
        </GridItem>
        <GridItem data-sentry-element="GridItem" data-sentry-source-file="CbParticipantPickerLayout.tsx">
          <CbParticipantCardHeader title="Selected Learners" buttonText="Clear" listLength={selectedParticipants?.length || 0} ariaLabel="Clear all participants" btnColor="cloud.900" btnBackgroundColor="none" hoverColor="cloud.500" handleClick={handleClearAllParticipants} data-sentry-element="CbParticipantCardHeader" data-sentry-source-file="CbParticipantPickerLayout.tsx" />
          {selectedParticipants.length ? <Box border="2px solid" borderColor="cloud.300" borderRadius={6} marginTop={4} padding={1} maxHeight={maxHeight} overflowY="auto">
              {selectedParticipants.map((participant, index) => {
            const team = participant.teams.filter(team => team.id === teamId);
            return <CbParticipantSelectedCard key={participant.id} name={participant.name} notificationsEnabled={team[0]?.notificationsEnabled} showNotificationSettings={showNotificationSettings && teamMembershipPersisted(participant)} imageUrl={participant.profileImage} handleClick={() => handleRemoveParticipant(index, participant.id as number)} handlePrimarySelected={() => {
              if (handlePrimarySelected) {
                handlePrimarySelected(team[0].id, team[0]?.notificationsEnabled || false, participant.id);
              }
            }} />;
          })}
            </Box> : <Text fontSize={{
          md: '12px'
        }} fontFamily="codenext" color={'luigisPants.200'} marginTop={6}>
              {' Please add a learner '}
            </Text>}
        </GridItem>
      </Grid>
    </>;
};